import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Typography,
  Paper,
  Stack,
  Chip,
  Divider,
  TextField,
} from "@mui/material";
import { socketWex } from "../../utils/Socket";
import { AuthContext } from "../../Auth/Context";
import useWexClient from "../../hooks/Clients/wexClient,";
import useCancellations from "../../hooks/useCancellations";

/**
 * Imports de Componentes como tablas, botones, alertas y modales
 */
import SelectComponent from "../atoms/Select";
import TableLine from "../atoms/TableLine";
import ButtonComponent from "../atoms/ButtonComponent";
import AlertComponent from "../atoms/Alert";
import MuiModal from "../atoms/MuiModal";

function CabinTables({
  routes = [],
  pending = [],
  onAssign,
  canCancel,
  requirePin,
  canReassign
}) {
  const { payload } = useContext(AuthContext);
  const { sendCancellationPin, cancelAssignment, loader } = useCancellations();
  const { getListClassifications } = useWexClient();
  const [idAssociative, setIdAssociative] = useState(null);
  const [idCabin, setIdCabin] = useState(null);
  const [serviceId, setServiceId] = useState(null);

  /**
   * Estados necesarios para botones
   */

  const [enabledAgents, setEnabledAgents] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [loadingAgents, setLoadingAgents] = useState({});
  const [checkInMessage, setCheckInMessage] = useState("");
  const [typeAlert, setTypeAlert] = useState("success");
  const [modalStep, setModalStep] = useState(1);
  const [pin, setPin] = useState("");
  // Estado para controlar qué ruta se ha seleccionado para ver más acciones y la visibilidad del modal
  const [selectedRoute, setSelectedRoute] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  //
  const [optionsClass, setOptionsClass] = useState([]);

  const [selectedOptionClass, setSelectedOptionClass] = useState(() => {
    if (optionsClass.length > 0) {
      return optionsClass[0]?._id;
    }
    return null;
  });

  const fetchOptionsClass = (idService) => {
    getListClassifications(idService).then((response) => {
      if (response?.success === false) {
        console.error(response.message || "Error al cargar clasificaciones");
        return;
      }
      const formattedOptionClass = [
        {
          _id: "placeholder",
          id: "00001",
          name: "Selecciona una opción",
        },
        ...response
          .filter((item) => item.typeUse === "_CANCELED_") //filtro por cancelado
          .map((item) => ({
            _id: item._id, // para el key del MenuItem
            id: item._id, // para valueSelect="id"
            name: item.name, // texto que muestra el Select
          })),
      ];

      setOptionsClass(formattedOptionClass);
      setSelectedOptionClass("00001");
    });
  };

  useEffect(() => {
    //console.log("canCancel actualizado:", canCancel);
    //.log("PIN REQUIERE", requirePin);
  }, [requirePin, canCancel]);

  useEffect(() => {
    if (!payload) return;

    fetchOptionsClass(payload.service);
  }, [payload]);

  useEffect(() => {
    if (payload) {
      setIdAssociative(payload?.associative);
      setIdCabin(payload?._id);
      setServiceId(payload?.service);
    }
    //console.log(idAssociative, idCabin, serviceId);
  }, [payload]);

  // Sincronización inicial al cargar o recibir rutas
  useEffect(() => {
    if (routes && routes.length > 0) {
      const initialEnabled = {};
      routes.forEach((route) => {
        if (route.raw?.enabledCheckin) {
          const agentId = route.raw.agent?._id;
          if (agentId) {
            initialEnabled[agentId] = true;
          }
        }
      });
      setEnabledAgents(initialEnabled);
    }
  }, [routes]);

  useEffect(() => {
    //  console.log("Registrando listener");
    const handleSuccessEnableCheckIn = (data) => {
      // console.log("RECIBIDO ", data);

      setCheckInMessage(data.message);
      setTypeAlert(data.success === true ? "success" : "error");
      setShowAlert(true);

      if (data.idAgent) {
        setLoadingAgents((prev) => {
          const newState = { ...prev };
          delete newState[data.idAgent];
          return newState;
        });
      }

      if (data.success === true && data.idAgent) {
        setEnabledAgents((prev) => ({ ...prev, [data.idAgent]: true }));
      }
    };

    socketWex.on("success-enable-checkin-adjuster", handleSuccessEnableCheckIn);
    return () => {
      //console.log("Quitando listener");
      socketWex.off(
        "success-enable-checkin-adjuster",
        handleSuccessEnableCheckIn,
      );
    };
  }, []);

  const isAdmin = payload?.profile?.class === "_ADMIN_";
  /**
   * 🔵 Ajustadores en Ruta
   */
  const routeColumns = ["Ajustador", "Folio", "Acciones"];

  /**
   *
   * Botones de accion para ajustador en ruta
   */
  const actionButtons = (route) => {
    if (!route) return null;
    const currentAgentId = route.raw?.agent?._id;
    const isEnabled = enabledAgents[currentAgentId];
    const isLoading = loadingAgents[currentAgentId];

    return (
      <Stack
        direction="column"
        spacing={2}
        justifyContent="center"
        width="100%"
      >
        <Stack justifyContent="center" alignItems="center">
          <ButtonComponent
            label={
              isEnabled ? "Activo" : isLoading ? "..." : "Activar Check-In"
            }
            onClick={() => handlerActivateCheckIn(currentAgentId)}
            backgroundColor={isEnabled ? "#bdbdbd" : "#9a2edb"}
            color="white"
            width="70%"
            disabled={isEnabled || isLoading}
          />
        </Stack>
        {canCancel && (
          <Stack justifyContent="center" alignItems="center">
            <ButtonComponent
              label={"Cancelar Incidente"}
              onClick={handleRequestCancellationPin}
              backgroundColor="#1976d2"
              color="white"
              width="70%"
            />{" "}
          </Stack>
        )}
      </Stack>
    );
  };

  const renderRouteCell = (item, column) => {
    switch (column) {
      case "Ajustador":
        return (
          <Box>
            <Typography fontSize="13px" fontWeight="600" color="text.secondary">
              {item.raw.agent?.profile?.alias}
            </Typography>
            <Typography variant="caption">
              {`Aceptado: ${item.acceptedDate}`}
            </Typography>
          </Box>
        );
      case "Folio":
        return (
          <Typography fontSize="13px" fontWeight="600" color="text.secondary">
            {item.folio}
          </Typography>
        );

      case "Acciones":
        return (
          <ButtonComponent
            label={"ver mas"}
            onClick={() => handlerOpenModalCancel(item)}
            backgroundColor={"#9a2edb"}
            color="white"
            width="70%"
          />
        );
      default:
        return "-";
    }
  };
  /**
   * 🟡 Casos Pendientes
   */
  const pendingColumns = ["Folio Externo", "Cliente", "Estatus"];

  const renderPendingCell = (item, column) => {
    switch (column) {
      case "Folio Externo":
        return (
          <Typography fontSize="13px" fontWeight="600" color="text.secondary">
            {item.externalFolio}
          </Typography>
        );
      case "Cliente":
        return (
          <Typography fontSize="13px" fontWeight="600" color="text.secondary">
            {item.client}
          </Typography>
        );
      case "Estatus":
        const isNoTaken = item.statusText === "No tomado";
        const isRejected = item.statusText === "Rechazado";
        return (
          <Chip
            label={item.statusText}
            sx={{
              backgroundColor: isNoTaken
                ? "#ed6c02"
                : isRejected
                  ? "#d32f2f"
                  : "#9e9e9e",
              color: "white",
              fontWeight: "600",
            }}
            size="small"
          />
        );
      default:
        return "-";
    }
  };

  /**
   * Handlers para Ajustadores en Ruta
   */

  const handlerActivateCheckIn = (agentId) => {
    if (!agentId) return;
    setLoadingAgents((prev) => ({ ...prev, [agentId]: true }));
    socketWex.emit("enable-checkin-adjuster", { idAgent: agentId });
  };

  const handlerOpenModalCancel = (route) => {
    //console.log("ruta seleccionada", route);
    setSelectedRoute(route);
    setModalOpen(true);
    setModalStep(1);
    setPin("");
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedRoute(null);
    setModalStep(1);
    setPin("");
    setShowAlert(false);
  };

  const handleChangeClass = (value) => {
    setSelectedOptionClass(value);
  };

  const handleRequestCancellationPin = async () => {
    //console.log("Cancelar Incidente");
    if (!selectedRoute) return;

    if (!requirePin) {
      setModalStep(2);
      return;
    }

    let body = {
      idAssociative,
      idCabin,
      serviceId,
      _idHeader: selectedRoute.id,
      externalFolio:
        selectedRoute.externalFolio ||
        selectedRoute.raw?.externalFolio ||
        selectedRoute.folio,
    };
    //console.log("Body para PIN: ", body);
    const response = await sendCancellationPin(body);
    //console.log("Respuesta PIN: ", response);

    const isSuccess =
      response && (response.success === true || response.success === "true");
    setCheckInMessage(
      response?.message ||
        (isSuccess
          ? "Código enviado correctamente"
          : "Error al solicitar código"),
    );
    setTypeAlert(isSuccess ? "success" : "error");
    setShowAlert(true);

    if (isSuccess) {
      setModalStep(2);
    }
  };

  const handleConfirmCancellation = async () => {
    if (!selectedRoute) return;
    if (requirePin && !pin) return;

    let body = {
      idAgent: selectedRoute.raw?.agent?._id,
      _idHeader: selectedRoute.id,
      classification: selectedOptionClass,
      idCabin: payload._id,
    };

    if (requirePin) {
      body.code = pin;
    }

    //console.log("Body para Cancelar Asignación: ", body);
    const response = await cancelAssignment(body);
    //console.log("Respuesta Cancelar: ", response);

    const isSuccess =
      response && (response.success === true || response.success === "true");
    setCheckInMessage(
      response?.message ||
        (isSuccess
          ? "Operación finalizada con éxito"
          : "Error al cancelar asignación"),
    );
    setTypeAlert(isSuccess ? "success" : "error");
    setShowAlert(true);

    if (isSuccess) {
      setTimeout(() => {
        handleCloseModal();
      }, 2000);
    }
  };

  return (
    <Stack direction="column" spacing={2} sx={{ mt: 3 }}>
      {/* 🔵 CARD AJUSTADORES */}
      <Paper
        elevation={4}
        sx={{
          flex: 1,
          minWidth: 0, //
          p: 2,
          borderRadius: 3,
          background: "rgba(255,255,255,0.95)",
        }}
      >
        <Typography variant="h6" mb={1}>
          Ajustadores en Ruta ({routes.length})
        </Typography>

        <Box
          sx={{
            maxHeight: 320,
            border: "1px solid #e0e0e0",
            flex: 1,
            minHeight: 0,
            overflowX: "auto", //  scroll horizontal
            overflowY: "auto", //  scroll vertical
            borderRadius: "8px",
            position: "relative",
            "&::-webkit-scrollbar": {
              height: "10px",
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#999",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#666",
              },
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f0f0f0",
            },
            // Para Firefox
            scrollbarWidth: "thin",
            scrollbarColor: "#999 #f0f0f0",
          }}
        >
          <TableLine
            data={routes}
            columnTitles={routeColumns}
            cellComponent={renderRouteCell}
          />
        </Box>
      </Paper>

      {/* 🟡 CARD PENDIENTES */}
      <Paper
        elevation={4}
        sx={{
          flex: 1,
          minWidth: 0,
          p: 2,
          borderRadius: 3,
          background: "rgba(255,255,255,0.95)",
        }}
      >
        <Typography variant="h6" mb={1}>
          Casos Pendientes ({pending.length})
        </Typography>

        <Box
          sx={{
            maxHeight: 320,
            border: "1px solid #e0e0e0",
            flex: 1,
            minHeight: 0,
            overflowX: "auto", //  scroll horizontal
            overflowY: "auto", //  scroll vertical
            borderRadius: "8px",
            position: "relative",
            "&::-webkit-scrollbar": {
              height: "10px",
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#999",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#666",
              },
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f0f0f0",
            },
            // Para Firefox
            scrollbarWidth: "thin",
            scrollbarColor: "#999 #f0f0f0",
          }}
        >
          <TableLine
            data={pending}
            columnTitles={pendingColumns}
            cellComponent={renderPendingCell}
            showActionColumn={canReassign === true}
            actionColumnTitle="Acción"
            actionColumnLabel="Asignar"
            onActionClick={(item) => {
              onAssign(item);
            }}
          />
        </Box>
      </Paper>

      {/* Modal de Acciones para Ajustador */}
      <MuiModal
        title="Acciones de Ajustador"
        subtitle={
          selectedRoute?.raw?.agent?.profile?.alias ||
          selectedRoute?.raw?.agent?.user
        }
        visible={modalOpen}
        onClose={handleCloseModal}
        width="450px"
      >
        {selectedRoute && (
          <Stack spacing={3} p={3} alignItems="center">
            {showAlert && (
              <Box sx={{ width: "100%", mb: 1 }}>
                <AlertComponent
                  message={checkInMessage}
                  typeAlert={typeAlert}
                  handleClose={() => setShowAlert(false)}
                />
              </Box>
            )}

            {modalStep === 1 ? (
              <>
                <Box sx={{ width: "100%", textAlign: "left" }}>
                  <Typography variant="body1" sx={{ mb: 1.5 }}>
                    <strong>Alias:</strong>{" "}
                    {selectedRoute.raw?.agent?.profile?.alias || "-"}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1.5 }}>
                    <strong>Usuario:</strong>{" "}
                    {selectedRoute.raw?.agent?.user || "-"}
                  </Typography>
                  <Typography variant="body1" sx={{ mb: 1.5 }}>
                    <strong>Folio:</strong> {selectedRoute.folio || "-"}
                  </Typography>
                </Box>
                <Divider sx={{ width: "100%", my: 1 }} />
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  width="100%"
                >
                  {actionButtons(selectedRoute)}
                </Stack>
              </>
            ) : (
              <>
                {requirePin && (
                  <Box sx={{ width: "100%", textAlign: "center" }}>
                    <Typography
                      variant="h6"
                      color="textSecondary"
                      sx={{ mb: 2 }}
                    >
                      Ingresar PIN de Cancelación
                    </Typography>
                    <Typography variant="body2" color="gray" sx={{ mb: 3 }}>
                      Se ha enviado un código de seguridad. Por favor, ingrésalo
                      a continuación para confirmar la cancelación.
                    </Typography>
                    <TextField
                      fullWidth
                      label="PIN de Cancelación"
                      variant="outlined"
                      value={pin}
                      onChange={(e) => setPin(e.target.value)}
                      sx={{ mb: 2 }}
                      placeholder="Escribe el PIN aquí"
                      inputProps={{
                        style: {
                          textAlign: "center",
                          letterSpacing: "4px",
                          fontSize: "18px",
                          fontWeight: "bold",
                        },
                      }}
                    />
                  </Box>
                )}
                <Box sx={{ width: "100%", textAlign: "left" }}>
                  <Typography variant="body1" color="gray" sx={{ mb: 3 }}>
                    Selecciona una clasificacion.
                  </Typography>
                  <SelectComponent
                    label="Clasificación"
                    options={optionsClass}
                    valueSelect="id"
                    value={selectedOptionClass}
                    onChange={(e) => handleChangeClass(e.target.value)}
                  />
                </Box>

                <Divider sx={{ width: "100%", my: 1 }} />
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="center"
                  width="100%"
                >
                  <ButtonComponent
                    label="Regresar"
                    onClick={() => {
                      setModalStep(1);
                      setShowAlert(false);
                    }}
                    backgroundColor="#9e9e9e"
                    color="white"
                    width="70%"
                  />
                  <ButtonComponent
                    label={loader ? "Confirmando..." : "Confirmar"}
                    onClick={handleConfirmCancellation}
                    backgroundColor={"#9a2edb"}
                    color="white"
                    width="70%"
                    disabled={(requirePin && !pin) || loader}
                  />
                </Stack>
              </>
            )}
          </Stack>
        )}
      </MuiModal>
    </Stack>
  );
}

export default CabinTables;
